import { render } from "./editCompany.vue?vue&type=template&id=7bb60564&scoped=true"
import script from "./editCompany.vue?vue&type=script&lang=js"
export * from "./editCompany.vue?vue&type=script&lang=js"

import "./editCompany.vue?vue&type=style&index=0&id=7bb60564&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb60564"]])

export default __exports__